/**
 * Skin Analysis Plan – feature flags for radar charts, summary, and routine.
 * Used by Skin Results and Skin Routine pages (skin + kiosk) when the skin analysis flow is selected.
 *
 * Plan presets:
 * - standard: no radar charts.
 * - growth: main radar on, before radar off.
 * - pro:    main + before radar on.
 *
 * Capture control: In skin flow, side capture is controlled by fetched capture_mode from /capture endpoint.
 * "side" => front+left+right, "basic" => front only. Plan-based side capture is deprecated.
 *
 * Plan is fetched from page-setup (external_fields.plan) via useSkinAnalysisPlan() from SkinAnalysisPlanContext.
 * Only the plan from the fetch URL is used; no default plan.
 */

const VALID_PLANS = ['standard', 'growth', 'pro'];

/**
 * Given a plan string from page-setup ('standard' | 'growth' | 'pro'), returns all feature flags.
 * Only valid plan values from the fetch are used; missing or invalid plan yields all flags false.
 */
export function getPlanFlags(plan) {
  const p = plan && VALID_PLANS.includes(String(plan).toLowerCase().trim())
    ? String(plan).toLowerCase().trim()
    : null;
  const ENABLE_RADAR_CHART = p === 'growth' || p === 'pro';
  const ENABLE_BEFORE_RADAR_CHART = p === 'pro';
  // Skin side-capture is controlled by fetched capture_mode, not plan.
  const ENABLE_SIDE_CAPTURE = false;
  return {
    ENABLE_RADAR_CHART,
    ENABLE_BEFORE_RADAR_CHART,
    ENABLE_SIDE_CAPTURE,
  };
}

// ---- Static exports (no plan = all flags false; use useSkinAnalysisPlan() in app) ----
const _flags = getPlanFlags(null);
export const ENABLE_RADAR_CHART = _flags.ENABLE_RADAR_CHART;
export const ENABLE_BEFORE_RADAR_CHART = _flags.ENABLE_BEFORE_RADAR_CHART;
export const ENABLE_SIDE_CAPTURE = _flags.ENABLE_SIDE_CAPTURE;
